import createIcon from "@impero-com/common/img/create-icon.svg";
import { t } from "@impero-com/common/utils/i18n";
import { ActionSpec } from "@impero-com/ui";

import folderIcon from "img/folder-icon.svg";

import { LegacyRoute } from "../../../legacyRoutes";
import { WebRoute } from "../../../routes";

import type { ReportListPageType } from "./layout";
import { buildReportUrl } from "./urlUtils";

function newReportAction(pageType: ReportListPageType): ActionSpec {
    return {
        id: "action-create-report",
        type: "Dropdown",
        label: t("Report_List_Toolbar_CreateNew"),
        icon: { svg: createIcon },
        items: [
            {
                key: "action-create-report-status",
                title: t("Report_List_Toolbar_CreateNew_Status"),
                description: t(
                    "Report_List_Toolbar_CreateNew_Status_Description"
                ),
                action: {
                    link: {
                        href: buildReportUrl(
                            LegacyRoute.REPORT_CONTROL_RESULT_STATUS,
                            pageType
                        ),
                    },
                },
            },
            {
                key: "action-create-report-task-based",
                title: t("Report_List_Toolbar_CreateNew_Classification"),
                description: t(
                    "Report_List_Toolbar_CreateNew_Classification_Description"
                ),
                action: {
                    link: {
                        href: LegacyRoute.CLASSIFICATION_CREATE,
                    },
                },
            },
            {
                key: "action-create-report-workload",
                title: t("Report_List_Toolbar_CreateNew_Workload"),
                description: t(
                    "Report_List_Toolbar_CreateNew_Workload_Description"
                ),
                action: {
                    link: {
                        href: buildReportUrl(
                            LegacyRoute.REPORT_CONTROL_RESULT_STATUS,
                            pageType,
                            { workload: "" }
                        ),
                    },
                },
            },
        ],
    };
}

function classificationSavedTemplatesLinkAction(): ActionSpec {
    return {
        id: "action-classification-saved-templates",
        label: t("Report_List_Toolbar_ClassificationSavedTemplates"),
        link: {
            to: WebRoute.REPORTS_CLASSIFICATION_CLASSIFICATIONS,
        },
        icon: {
            svg: folderIcon,
        },
    };
}

export { newReportAction, classificationSavedTemplatesLinkAction };
